

export class EmployeeRelationDto implements IEmployeeRelationDto {
    id!: number | undefined;
    employeeId!: number;
    name!: string | undefined;
    birthDate!: Date | undefined;
    aadharNo!: string | undefined;
    relation!: string | undefined;
    isDeath!: boolean;
    isNominee!: boolean;

    constructor(data?: IEmployeeRelationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.name = _data["name"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.aadharNo = _data["aadharNo"];
            this.relation = _data["relation"];
            this.isDeath = _data["isDeath"];
            this.isNominee = _data["isNominee"];
        }
    }

    static fromJS(data: any): EmployeeRelationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeRelationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["name"] = this.name;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["aadharNo"] = this.aadharNo;
        data["relation"] = this.relation;
        data["isDeath"] = this.isDeath;
        data["isNominee"] = this.isNominee;
        return data; 
    }
}

export interface IEmployeeRelationDto {
    id: number | undefined;
    employeeId: number;
    name: string | undefined;
    birthDate: Date | undefined;
    aadharNo: string | undefined;
    relation: string | undefined;
    isDeath: boolean;
    isNominee: boolean;
}

